module.exports = __webpack_public_path__ + "static/media/german-alphabet-letters.d5267ae4.jpg";